import { FC } from 'react'
import styled from 'styled-components'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { FormTextInput } from 'Components/Inputs/FormTextInput'
import { FormCheckbox } from 'Components/Inputs/Checkbox/FormCheckbox'
import { StyledButton } from 'Components/Buttons/StyledButton'
import { EmployerMetaField } from 'Services/employerService'
import { ButtonContainer, spacingMD } from 'Utils/styles/spacing'
import { useMetaFieldForm } from './useMetaFieldForm'

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacingMD};
`

type MetaFieldFormProps = {
  closeModal: () => void
  metaField: EmployerMetaField | null
}

export const MetaFieldForm: FC<MetaFieldFormProps> = ({ closeModal, metaField }) => {
  const { register, handleSubmit, handleSubmission, errors, canSubmit, isLoading } =
    useMetaFieldForm(closeModal, metaField)

  return (
    <FormContainer onSubmit={handleSubmit(handleSubmission)}>
      <ModalHeader>{metaField ? 'Edit metadata field' : 'Add metadata field'}</ModalHeader>
      <FormTextInput
        fieldName="fieldName"
        label="Field name"
        register={register}
        registerOptions={{ validate: (value) => typeof value === 'string' && !!value.trim() }}
        errorPresent={!!errors.fieldName}
      />
      <FormCheckbox
        id="metaField.required"
        name="required"
        labelTitle="Required"
        labelDescription="Enabled and invited users must have a value."
        register={register}
        defaultValue={metaField?.required}
      />
      <FormCheckbox
        id="metaField.unique"
        name="unique"
        labelTitle="Unique"
        labelDescription="No two users can have the same value, including removed and disabled users."
        register={register}
        defaultValue={metaField?.unique}
      />
      <ButtonContainer>
        <StyledButton primary id="save.label" disabled={!canSubmit} isLoading={isLoading} />
      </ButtonContainer>
    </FormContainer>
  )
}
